import { TypographyLogo } from '../../assets/icons/common';
import styles from './style.module.scss';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    headerTitle: string;
};

function ExamLayout(props: Props) {
    const { children, headerTitle } = props;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <TypographyLogo width={145} height={36} className={styles.typoLogo} />
                <span className={styles.title}>{headerTitle}</span>
            </div>
            <div className={styles.child}>{children}</div>
        </div>
    );
};

export default ExamLayout;
